import React from 'react';
import './meeting.css';
import { Paragraph } from '../../../components/paragraph';
import { IconButton } from '../../../components/icon-button';

const Meeting = props => {
    const { title, description, onClick } = props;

    return (
        <div className="meeting">
            <div className="meeting__text">
                <Paragraph
                    colorScheme="dark"
                    fontSize="large"
                    fontWeight="bold"
                    withSpacing={false}
                    withIndent={true}
                >
                    {title}
                </Paragraph>
                <Paragraph
                    colorScheme="dark"
                    withSpacing={true}
                    withIndent={true}
                >
                    {description}
                </Paragraph>
            </div>
            <div className="meeting__decision">
                <div className="meeting__decision-choice">
                    <Paragraph colorScheme="dark" withSpacing={false}>
                        No
                    </Paragraph>
                    <IconButton
                        onClick={() => onClick('ignore')}
                        iconName="cross"
                        size="small"
                        type="decision"
                        altText="no"
                    />
                </div>
                <div className="meeting__decision-choice">
                    <Paragraph colorScheme="dark" withSpacing={false}>
                        Yes
                    </Paragraph>
                    <IconButton
                        onClick={() => onClick('attend')}
                        iconName="tick"
                        size="small"
                        type="decision"
                        altText="yes"
                    />
                </div>
            </div>
        </div>
    );
};

export { Meeting };
